import { render, staticRenderFns } from "./DeleteAllDialog.vue?vue&type=template&id=2f9207d7&scoped=true"
import script from "./DeleteAllDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteAllDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9207d7",
  null
  
)

export default component.exports